import Field from '@app/components/common/form/Field';
import {
  PAGE_BREAKPOINTS,
  AFFILIATION_DEALER
} from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { Toggle } from 'cat-ecommerce-alloy';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import styles from '../../styles.module.scss';

const ShowNotesToggle = () => {
  const [t] = useTranslation();
  const { values, setFieldValue } = useFormikContext();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  let displayLineItemNotes = useSelector(
    s => s.shoppingPreferences.shoppingPreferencesData.displayLineItemNotes
  );
  const userAffiliation = useSelector(s => s.common.userAffiliation);
  const isDealerUser = userAffiliation === AFFILIATION_DEALER;
  if (isDealerUser) {
    displayLineItemNotes = true;
  }
  useEffect(() => {
    if (
      (values.showNotes === undefined || values.showNotes === null) &&
      displayLineItemNotes !== undefined &&
      displayLineItemNotes !== null
    ) {
      setFieldValue('showNotes', displayLineItemNotes, false);
    }
  }, [displayLineItemNotes, setFieldValue, values.showNotes]);

  return (
    <Field
      id="show_note"
      label={t('SHOW_NOTES')}
      labelClassName={cx(
        'd-flex align-items-end',
        styles['show-toggle__label']
      )}
      name="showNotes"
      size="large"
      checked={values.showNotes}
      aria-checked={values.showNotes}
      className={cx(
        'text-sm u-color--DarkGray d-print-none',
        {
          'd-flex': isMD,
          'px-2': !isMD
        },
        styles['shopping-cart-page__toggle']
      )}
      as={Toggle}
      type="switch"
    />
  );
};

export default ShowNotesToggle;
